import firedux from '../firedux'

import {
  GROUP_CHAT_SCOPES_ENDPOINT
} from '../../config/constants'

export default (groupId) => {
  if (!groupId) throw new Error('cannot get group scope because no groupId is given')

  const ref = firedux.ref.child(GROUP_CHAT_SCOPES_ENDPOINT).child(groupId)

  return ref.once('value')
    .then((snapshot) => snapshot.val())
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/getters/group_chat_scope.js
 **/